import { WorksheetDomain } from '@mathflat/domain/@entities'
import { ReportDomain } from '@mathflat/domain/@entities/(Content)/Report/domain'
import { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain'

import commonRepo from '@/repository/common.repo'

/**
 * 학습지 태그 목록 (WorksheetDomain.TAG 기반)
 */
export const WORKSHEET_TAGS = Object.entries(WorksheetDomain.TAG).map(([label, key]) => ({
  key,
  label,
})) as ReadonlyArray<{ key: ValueOf<typeof WorksheetDomain.TAG>; label: string }>

/**
 * 교재 타입 목록 (WorkbookDomain.TYPE 기반)
 */
export const WORKBOOK_TYPES = [
  {
    key: WorkbookDomain.TYPE['내교재'],
    label: '내교재',
  },
  {
    key: WorkbookDomain.TYPE['학원그룹교재'],
    label: '학원그룹교재',
  },
  {
    key: WorkbookDomain.TYPE['시중교재'],
    label: '시중교재',
  },
  {
    key: WorkbookDomain.TYPE['교과서'],
    label: '교과서',
  },
  {
    key: WorkbookDomain.TYPE['커스텀시그니처교재'],
    label: '시그니처교재',
  },
] as ReadonlyArray<{ key: ValueOf<typeof WorkbookDomain.TYPE>; label: string }>

export type V2ReportSection = {
  key: ValueOf<typeof ReportDomain.COMPONENT_SECTIONS>
  label: string
  hasSubOption?: boolean
  subOption?: {
    key: ValueOf<typeof ReportDomain.COMPONENT_SECTIONS>
    label: string
  }
}

export const V2_REPORT_CONTENT_SECTIONS: ReadonlyArray<V2ReportSection> = [
  {
    key: ReportDomain.COMPONENT_SECTIONS['표지'],
    label: '표지',
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['월별분석'],
    label: '월간분석',
    hasSubOption: true,
    subOption: {
      key: ReportDomain.COMPONENT_SECTIONS['선생님의견'],
      label: '선생님의견',
    },
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['주별분석'],
    label: '주간분석',
    hasSubOption: true,
    subOption: {
      key: ReportDomain.COMPONENT_SECTIONS['난이도별분석'],
      label: '난이도별분석',
    },
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['학습내역'],
    label: '학습내역',
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['학습성과'],
    label: '학습성과',
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['진단결과'],
    label: '진단결과',
  },
  {
    key: ReportDomain.COMPONENT_SECTIONS['학습평가'],
    label: '학습평가',
  },
] as const

/**
 * V2 보고서 컴포넌트 키 목록 (1차원 배열)
 * 메인 섹션 키 + 서브옵션 키를 모두 포함
 */
export const V2_REPORT_COMPONENT_KEYS: ReadonlyArray<
  ValueOf<typeof ReportDomain.COMPONENT_SECTIONS>
> = V2_REPORT_CONTENT_SECTIONS.flatMap((section) =>
  section.subOption ? [section.key, section.subOption.key] : [section.key],
)

export const USAGE_OPTIONS = [
  { key: 'USED', label: '사용' },
  { key: 'NOT_USED', label: '미사용' },
] as const

export const COMPARISON_OPTIONS = [
  { key: 'NATIONAL', label: '전국 동일 학년 평균', shortLabel: '전국' },
  {
    key: 'GRADE',
    get label() {
      return `${commonRepo.agencyNameInKor} 내 동일 학년 평균`
    },
    shortLabel: '학년',
  },
  {
    key: 'LESSON_CLASS',
    get label() {
      return `${commonRepo.agencyNameInKor} 내 동일 반 평균`
    },
    shortLabel: '반',
  },
  { key: 'NOT_USED', label: '미사용', shortLabel: '미사용' },
] as const

export type UsageOptionKey = (typeof USAGE_OPTIONS)[number]['key']
export type ComparisonOptionKey = (typeof COMPARISON_OPTIONS)[number]['key']
